module.exports = __webpack_public_path__ + "static/card-project3-9e15b8b0e47f3b5483816fccdce6b794.jpg";